import { useEffect, useRef } from "react";
import { trackEmEvent } from "../analytics/em/sdk";
import type { InstallTrackSource } from "../analytics/em/events";

export type InstallEntryCloseReason = "close_button";

export const trackInstallEntryView = (
  source: InstallTrackSource,
  closable: boolean,
): void => {
  trackEmEvent("apk_install_entry_view", {
    source,
    closable,
  });
};

export const trackInstallEntryClose = (
  source: InstallTrackSource,
  closeReason: InstallEntryCloseReason = "close_button",
): void => {
  trackEmEvent("apk_install_entry_close", {
    source,
    closeReason,
  });
};

export const useTrackInstallEntryView = ({
  visible,
  source,
  closable,
}: {
  visible: boolean;
  source: InstallTrackSource;
  closable: boolean;
}): void => {
  const wasVisibleRef = useRef(false);

  useEffect(() => {
    if (!visible) {
      wasVisibleRef.current = false;
      return;
    }
    if (wasVisibleRef.current) {
      return;
    }

    wasVisibleRef.current = true;
    trackInstallEntryView(source, closable);
  }, [closable, source, visible]);
};
